import { Component } from '@angular/core';
import { NavbarComponent } from '../../components/navbar/navbar.component'; 
import { FormsComponent } from '../../components/forms/forms.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'app-register',
  imports: [
    NavbarComponent,
    FormsComponent,
    FooterComponent,
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent {

}
